import styled from '@emotion/styled';
import theme from '../../../theme';

interface Props {
  color: keyof typeof theme.colors;
  space?: keyof typeof theme.space;
}

const WithIcon = styled.span<Props>(({
  theme,
  color,
  space = 's'
}) => ({
  display: 'inline-flex',
  alignItems: 'center',
  '>:not(svg)': {
    flexGrow: 1,
  },
  '> svg': {
    marginInlineEnd: theme.space[space],
    flexShrink: 0,

    '> path': {
      fill: theme.colors[color],
    },
  },
}));

export default WithIcon;
